module.exports = __webpack_public_path__ + "img/sh-nike-marathon-2016-2.926519d0.jpg";